import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "./api";
import {handleResponseStatus, updateIdField, updateItem} from "./utils";

const initialState = {
    items: [],
    fetchStatus: "idle",
    fetchByIdStatus: "idle",
    error: null,
};

//Fetch customer
export const fetchAllContact = createAsyncThunk('contact/fetchFeedback',
    async () => {
        try {
            const response = await api.get(`/contactus`);
            return {...response};
        } catch (error) {
            if (error.response) return error.response;
            throw error;
        }
    }
);

// Fetch customer by ID
export const fetchContactById = createAsyncThunk('contact/fetchContactById',
    async ({id}) => {
        try {
            const response = await api.get(`/contactus/${id}`);
            return {...response};
        } catch (error) {
            if (error.response) return error.response;
            throw error;
        }
    }
);

const contactSlice = createSlice({
    name: "contact",
    initialState,
    extraReducers: (builder) => {
        builder
            // Fetch Customer
            .addCase(fetchAllContact.pending, (state) => {
                state.fetchStatus = 'loading';
            })
            .addCase(fetchAllContact.fulfilled, (state, action) => {
                const {fetchStatus, error} = handleResponseStatus(action.payload, 'fetchStatus');
                const {data} = action.payload.data;
                state.items = fetchStatus === "success" ? updateIdField(data) : state.items;
                state.fetchStatus = fetchStatus;
                state.error = error;
            })
            .addCase(fetchAllContact.rejected, (state, action) => {
                state.fetchStatus = 'failed';
                state.error = action.error.message;
            })

            // Fetch contact by ID
            .addCase(fetchContactById.pending, (state) => {
                state.fetchByIdStatus = 'loading';
            })
            .addCase(fetchContactById.fulfilled, (state, action) => {
                const {fetchByIdStatus, error} = handleResponseStatus(action.payload, 'fetchByIdStatus');
                state.items = fetchByIdStatus === "success" ? updateItem(action.payload.data.data, state.items) : state.items;
                state.fetchByIdStatus = fetchByIdStatus;
                state.error = error;
            })
            .addCase(fetchContactById.rejected, (state, action) => {
                state.fetchByIdStatus = 'failed';
                state.error = action.error.message;
            })
    }
});

export default contactSlice.reducer;



